import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { CoreService } from 'app/services/entidades/core.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DashboardService extends CoreService {

  constructor(
    private _http: Http
  ) {
    super(_http);
  }

  public get(): Observable<any> {
    return this.getMethod('dashboard/');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/entidades/dashboard.service.ts